var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUfoCow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "saiki_stories-taken",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#saiki_stories-taken:not(.animated) .animable {\n      opacity: 0;\n    }\n\n    svg#saiki_stories-taken.animated #saiki--Mountains--inject-2 {\n      animation: 6s Infinite linear floating;\n      animation-delay: 0s;\n    }\n\n    svg#saiki_stories-taken.animated #saiki--space-ship--inject-2 {\n      animation: 6s Infinite linear floating;\n      animation-delay: 0s;\n    }\n\n    svg#saiki_stories-taken.animated #saiki--Cow--inject-2 {\n      animation: 6s Infinite linear floating;\n      animation-delay: 0.5s;\n    }\n\n    @keyframes floating {\n      0% {\n        opacity: 1;\n        transform: translateY(0px);\n      }\n\n      50% {\n        transform: translateY(-10px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: translateY(0px);\n      }\n    }\n\n    .animator-hidden {\n      display: none;\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "saiki--background-simple--inject-2",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "245.911px 253.784px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.91,233.54s13.66-32.29,1.24-83.21-69.54-53.41-118-59.61S286,53.46,233.85,49.73,137,78.3,128.29,111.83s1.24,50.92-36,77S19,237.26,33.9,285.7s52.16,48.43,58.37,80.72,49.68,72,100.6,88.18S278.56,426,325.75,428.52s91.91-1.25,114.26-37.26-9.94-70.79-3.73-95.63S450,257.13,454.91,233.54Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "245.911px 253.784px"
    },
    id: "eleyfo6tlfbp8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elejuo77u8y1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.91,233.54s13.66-32.29,1.24-83.21-69.54-53.41-118-59.61S286,53.46,233.85,49.73,137,78.3,128.29,111.83s1.24,50.92-36,77S19,237.26,33.9,285.7s52.16,48.43,58.37,80.72,49.68,72,100.6,88.18S278.56,426,325.75,428.52s91.91-1.25,114.26-37.26-9.94-70.79-3.73-95.63S450,257.13,454.91,233.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "245.911px 253.784px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "saiki--Mountains--inject-2",
    className: "animable",
    style: {
      transformOrigin: "254.588px 379.744px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440,391.26c10-16.15,9.06-32,5.51-46.9-1.83-.14-3.86-.24-6.18-.24-14.83,0-18.32,25.31-27,26.18s-21.81-13.09-36.64-13.09-34,60.2-41,64.57-12.22-3.49-27.05-9.6-34,13.09-51.48,19.19-36.64-4.36-42.75-15.7-20.07-44.5-32.28-43.63-24.43,9.6-31.41,1.75-30.54-71.55-39.26-72.42c-5.69-.57-31.8,15.2-49.27,26.23C75,340,88.72,348,92.27,366.42c6.21,32.29,49.68,72,100.6,88.18S278.56,426,325.75,428.52,417.66,427.27,440,391.26Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "254.588px 379.744px"
    },
    id: "elxvjbtvnm9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3i18c8hg37p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440,391.26c10-16.15,9.06-32,5.51-46.9-1.83-.14-3.86-.24-6.18-.24-14.83,0-18.32,25.31-27,26.18s-21.81-13.09-36.64-13.09-34,60.2-41,64.57-12.22-3.49-27.05-9.6-34,13.09-51.48,19.19-36.64-4.36-42.75-15.7-20.07-44.5-32.28-43.63-24.43,9.6-31.41,1.75-30.54-71.55-39.26-72.42c-5.69-.57-31.8,15.2-49.27,26.23C75,340,88.72,348,92.27,366.42c6.21,32.29,49.68,72,100.6,88.18S278.56,426,325.75,428.52,417.66,427.27,440,391.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "254.588px 379.744px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "saiki--Stars--inject-2",
    className: "animable",
    style: {
      transformOrigin: "246.696px 181.362px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.65,217.8a4.56,4.56,0,1,0,4.55,4.56A4.56,4.56,0,0,0,405.65,217.8Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "405.64px 222.36px"
    },
    id: "elvmu9hdlfiui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.36,222.77a2.28,2.28,0,1,0,2.27,2.28A2.28,2.28,0,0,0,367.36,222.77Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "367.35px 225.05px"
    },
    id: "elpbjc2ujwu7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.14,180.75a2.28,2.28,0,1,0,2.27,2.28A2.28,2.28,0,0,0,414.14,180.75Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "414.13px 183.03px"
    },
    id: "elwlqcf0i6l8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.67,219.05a2.28,2.28,0,1,0,2.27,2.27A2.28,2.28,0,0,0,441.67,219.05Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "441.66px 221.33px"
    },
    id: "elppjsoj86s6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.55,273.86a4.55,4.55,0,1,0,6.25,1.57A4.55,4.55,0,0,0,372.55,273.86Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "374.892px 277.761px"
    },
    id: "el8n0k3rxt5dx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,244.35a2.27,2.27,0,1,0,3.12.78A2.28,2.28,0,0,0,351.74,244.35Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "352.911px 246.296px"
    },
    id: "elexacqtadczu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.82,262.89a2.27,2.27,0,1,0,3.12.78A2.27,2.27,0,0,0,411.82,262.89Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "412.991px 264.834px"
    },
    id: "el7k71r4ahrf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,306.18a2.28,2.28,0,1,0,3.12.78A2.28,2.28,0,0,0,393.12,306.18Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "394.288px 308.138px"
    },
    id: "elagev13aewws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,231.88a4.55,4.55,0,1,0,6.25,1.57A4.56,4.56,0,0,0,113.8,231.88Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "116.142px 235.783px"
    },
    id: "el9gf2nal47un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,202.36a2.28,2.28,0,1,0,3.12.79A2.29,2.29,0,0,0,93,202.36Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "94.1635px 204.323px"
    },
    id: "eliw5liisjgtp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.07,220.9a2.28,2.28,0,1,0,3.12.79A2.28,2.28,0,0,0,153.07,220.9Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "154.234px 222.861px"
    },
    id: "elf26vvezr54i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.36,264.2a2.27,2.27,0,1,0,3.13.78A2.28,2.28,0,0,0,134.36,264.2Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "135.539px 266.142px"
    },
    id: "elmfdl2044i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.36,273.72a4.55,4.55,0,1,0,6.25,1.57A4.55,4.55,0,0,0,71.36,273.72Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "73.7023px 277.621px"
    },
    id: "elqbyd43nc5xf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.55,244.21a2.27,2.27,0,1,0,3.12.78A2.27,2.27,0,0,0,50.55,244.21Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "51.7214px 246.154px"
    },
    id: "elkzj54c59l3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,262.75a2.27,2.27,0,1,0,3.13.78A2.27,2.27,0,0,0,110.63,262.75Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "111.809px 264.69px"
    },
    id: "elv29dze2lxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93,306a2.28,2.28,0,1,0,3.12.78A2.28,2.28,0,0,0,91.93,306Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "93.098px 307.958px"
    },
    id: "elgddbchjl2ed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39,69.7a4.55,4.55,0,1,0,6.08,2.09A4.56,4.56,0,0,0,174.39,69.7Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "176.383px 73.7919px"
    },
    id: "eldpokdx37iy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62,52.53a2.27,2.27,0,1,0,3,1A2.27,2.27,0,0,0,208.62,52.53Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "209.605px 54.5752px"
    },
    id: "elr6j0wq1zbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,100.87a2.28,2.28,0,0,0-1,3,2.28,2.28,0,1,0,1-3Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "186.058px 102.889px"
    },
    id: "elfzujp4bjq1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.47,88.47a2.28,2.28,0,1,0,3.05,1A2.28,2.28,0,0,0,143.47,88.47Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "144.49px 90.5089px"
    },
    id: "eln5lrpwlnvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.07,127.81A4.55,4.55,0,1,0,381.8,134,4.56,4.56,0,0,0,380.07,127.81Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "377.831px 131.772px"
    },
    id: "elrjt7rz3ih9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,113.31a2.27,2.27,0,1,0,.86,3.1A2.26,2.26,0,0,0,344.29,113.31Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "343.178px 115.288px"
    },
    id: "elzjljjooz7fq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.5,105.36a2.27,2.27,0,1,0,.86,3.1A2.26,2.26,0,0,0,397.5,105.36Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "396.388px 107.338px"
    },
    id: "el1nfkbc9schp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.58,150.57a2.28,2.28,0,1,0-.86-3.1A2.29,2.29,0,0,0,408.58,150.57Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "409.709px 148.588px"
    },
    id: "el8tlbshsho6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5sv4bpfyvhd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "246.696px 181.362px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.65,217.8a4.56,4.56,0,1,0,4.55,4.56A4.56,4.56,0,0,0,405.65,217.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "405.64px 222.36px"
    },
    id: "elsy0zxju0h3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.36,222.77a2.28,2.28,0,1,0,2.27,2.28A2.28,2.28,0,0,0,367.36,222.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "367.35px 225.05px"
    },
    id: "eljiq09x497b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.14,180.75a2.28,2.28,0,1,0,2.27,2.28A2.28,2.28,0,0,0,414.14,180.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "414.13px 183.03px"
    },
    id: "eli9qhl44tpwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.67,219.05a2.28,2.28,0,1,0,2.27,2.27A2.28,2.28,0,0,0,441.67,219.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "441.66px 221.33px"
    },
    id: "el90zs40h2ulw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.55,273.86a4.55,4.55,0,1,0,6.25,1.57A4.55,4.55,0,0,0,372.55,273.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "374.892px 277.761px"
    },
    id: "el3w8d5hcy7c7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,244.35a2.27,2.27,0,1,0,3.12.78A2.28,2.28,0,0,0,351.74,244.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "352.911px 246.296px"
    },
    id: "elozmv7e1eum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.82,262.89a2.27,2.27,0,1,0,3.12.78A2.27,2.27,0,0,0,411.82,262.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "412.991px 264.834px"
    },
    id: "elr4wlgcenymr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,306.18a2.28,2.28,0,1,0,3.12.78A2.28,2.28,0,0,0,393.12,306.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.288px 308.138px"
    },
    id: "elzrr69cexfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,231.88a4.55,4.55,0,1,0,6.25,1.57A4.56,4.56,0,0,0,113.8,231.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "116.142px 235.783px"
    },
    id: "elxcgcwizn6xc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,202.36a2.28,2.28,0,1,0,3.12.79A2.29,2.29,0,0,0,93,202.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "94.1635px 204.323px"
    },
    id: "elnomdnb1zjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.07,220.9a2.28,2.28,0,1,0,3.12.79A2.28,2.28,0,0,0,153.07,220.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "154.234px 222.861px"
    },
    id: "elk1i579ypcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.36,264.2a2.27,2.27,0,1,0,3.13.78A2.28,2.28,0,0,0,134.36,264.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "135.539px 266.142px"
    },
    id: "ellzyrs94j3l8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.36,273.72a4.55,4.55,0,1,0,6.25,1.57A4.55,4.55,0,0,0,71.36,273.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "73.7023px 277.621px"
    },
    id: "eleedt86fpaj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.55,244.21a2.27,2.27,0,1,0,3.12.78A2.27,2.27,0,0,0,50.55,244.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "51.7214px 246.154px"
    },
    id: "elpo0i4805l3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,262.75a2.27,2.27,0,1,0,3.13.78A2.27,2.27,0,0,0,110.63,262.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "111.809px 264.69px"
    },
    id: "ely6g97peh3y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93,306a2.28,2.28,0,1,0,3.12.78A2.28,2.28,0,0,0,91.93,306Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "93.098px 307.958px"
    },
    id: "el1l3ex2o1q3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39,69.7a4.55,4.55,0,1,0,6.08,2.09A4.56,4.56,0,0,0,174.39,69.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "176.383px 73.7919px"
    },
    id: "elykq3uzknfbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62,52.53a2.27,2.27,0,1,0,3,1A2.27,2.27,0,0,0,208.62,52.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "209.605px 54.5752px"
    },
    id: "elkzjnoqn2hx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,100.87a2.28,2.28,0,0,0-1,3,2.28,2.28,0,1,0,1-3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "186.058px 102.889px"
    },
    id: "elxrxkh52vl9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.47,88.47a2.28,2.28,0,1,0,3.05,1A2.28,2.28,0,0,0,143.47,88.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "144.49px 90.5089px"
    },
    id: "elpn5ek5io89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.07,127.81A4.55,4.55,0,1,0,381.8,134,4.56,4.56,0,0,0,380.07,127.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "377.831px 131.772px"
    },
    id: "el5a7jigf46u8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,113.31a2.27,2.27,0,1,0,.86,3.1A2.26,2.26,0,0,0,344.29,113.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "343.178px 115.288px"
    },
    id: "elci62s73hnck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.5,105.36a2.27,2.27,0,1,0,.86,3.1A2.26,2.26,0,0,0,397.5,105.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "396.388px 107.338px"
    },
    id: "elsq3jpjpxj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.58,150.57a2.28,2.28,0,1,0-.86-3.1A2.29,2.29,0,0,0,408.58,150.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "409.709px 148.588px"
    },
    id: "elp8n0chlkq5",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "saiki--space-ship--inject-2",
    className: "animable",
    style: {
      transformOrigin: "252.22px 272.546px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.22,
    cy: 132.09,
    rx: 57.8,
    ry: 45.12,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.22px 132.09px"
    },
    id: "el7wxg4g41wqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,103.75c8.6,7.53,13.83,17.46,13.83,28.34,0,23.54-24.44,42.62-54.59,42.62s-54.59-19.08-54.59-42.62c0-14.71,9.55-27.67,24.07-35.33",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.24px 135.735px"
    },
    id: "elryx8o5olzz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,93.68a65.74,65.74,0,0,1,13.61-3.48",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "235.355px 91.94px"
    },
    id: "elk5oemsic29c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.22,
    cy: 142.74,
    rx: 93.48,
    ry: 31.02,
    style: {
      fill: "rgb(96, 116, 203)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.22px 142.74px"
    },
    id: "elhbni1thiijf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.22,
    cy: 153.92,
    rx: 133.19,
    ry: 31.02,
    style: {
      fill: "rgb(96, 116, 203)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.22px 153.92px"
    },
    id: "elz9ouyclwlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.22,
    cy: 162.19,
    rx: 153.87,
    ry: 31.02,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.22px 162.19px"
    },
    id: "elscdxdv1os7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.3,
    cy: 162.18,
    rx: 115.24,
    ry: 21.68,
    style: {
      fill: "rgb(96, 116, 203)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.3px 162.18px"
    },
    id: "el31tjyingrkr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc4lxifdtgbk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.51,162.19H200.93L125.69,416.46a189.58,189.58,0,0,0,67.18,38.14c50.92,16.14,85.69-28.57,132.88-26.08,23,1.21,45.46.93,65-3.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "258.22px 310.156px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.22,
    cy: 162.19,
    rx: 51.29,
    ry: 10.34,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.22px 162.19px"
    },
    id: "elnmq7bexofh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.3,
    cy: 138.77,
    rx: 12.22,
    ry: 2.68,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.3px 138.77px"
    },
    id: "ele8h9tsc608",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.07,162c0,1-3.74,1.84-8.36,1.84s-8.37-.83-8.37-1.84,3.75-1.84,8.37-1.84S139.07,161,139.07,162Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "130.705px 162px"
    },
    id: "ela39tbbj0fra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.7,162c0,1-3.75,1.84-8.37,1.84S368,163,368,162s3.74-1.84,8.36-1.84S384.7,161,384.7,162Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "376.35px 162px"
    },
    id: "el9c7zjgh99bs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.76,
    cy: 147.34,
    rx: 11.42,
    ry: 2.51,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "327.76px 147.34px"
    },
    id: "eladzfq1ddq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.77,
    cy: 147.34,
    rx: 11.42,
    ry: 2.51,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "185.77px 147.34px"
    },
    id: "ela2wjxdamds6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.76,
    cy: 176.72,
    rx: 8.36,
    ry: 1.84,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "327.76px 176.72px"
    },
    id: "el3h899ot5b0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.77,
    cy: 176.72,
    rx: 8.36,
    ry: 1.84,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "185.77px 176.72px"
    },
    id: "elwrnyoy6rivn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.66,
    y1: 300.8,
    x2: 156.83,
    y2: 310.54,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "158.245px 305.67px"
    },
    id: "el4ba05sj4b7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.9,
    y1: 213.93,
    x2: 162.59,
    y2: 290.74,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "173.745px 252.335px"
    },
    id: "elaupbujbmbfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.59,
    y1: 166.79,
    x2: 187.33,
    y2: 205.57,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "192.96px 186.18px"
    },
    id: "el6t5n8b1fcr7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.51,
    y1: 162.19,
    x2: 351.83,
    y2: 305.57,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "327.67px 233.88px"
    },
    id: "elxu92gpo15k8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.88,
    y1: 174.82,
    x2: 210.64,
    y2: 237.46,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "216.26px 206.14px"
    },
    id: "elcixuo7jk44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.34,
    y1: 174.82,
    x2: 309.42,
    y2: 286.45,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "299.38px 230.635px"
    },
    id: "elisvvnnq6gvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.22,
    y1: 306.53,
    x2: 252.22,
    y2: 319.38,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.22px 312.955px"
    },
    id: "ell6icfu4vqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.22,
    y1: 193.22,
    x2: 252.22,
    y2: 294.48,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "252.22px 243.85px"
    },
    id: "elime5un89fn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.22,151.85a215.78,215.78,0,0,0-29.35,1.86c2.83,5.86,15.2,10.28,30,10.28s26.94-4.33,29.93-10.1A212.22,212.22,0,0,0,252.22,151.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      strokeWidth: "1.24191px",
      transformOrigin: "252.835px 157.918px"
    },
    id: "elxbsdd26euer",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "saiki--Cow--inject-2",
    className: "animable",
    style: {
      transformOrigin: "254.928px 396.272px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.29,405.66s.69,5.69,2.66,7,2.9,1.94,2.9,3.18,0,2.47-2.78,5.25-5.87,6.18-8.65,8.65-5.57,6.18-3.4,6.49,6.18.93,7.41-1.85.31-4.33,1.55-4.94a13.55,13.55,0,0,0,4-4.33c.61-1.24,4.94-2.78,5.56-5.56s2.09-3.93,3.05-6.45a38.93,38.93,0,0,0,1.58-5.91S284,400.41,276.29,405.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "278.207px 420.09px"
    },
    id: "elqmu2iuzj0dq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,408.67a21.72,21.72,0,0,0,2.53,2.37,7.69,7.69,0,0,0,1.92,1s-.14,1.63.89,2.08,2.08-.59,2.08-.59l2.23.29s.44,1.34,1.48,1.34,1.48-1.34,1.48-1.34l3.56-1.18s1.63,1.33,2.38.14a1.43,1.43,0,0,0-.15-1.92,4.7,4.7,0,0,0,1.93-2.67c.44-1.78-.6-2.38-1.93-2.38a56.31,56.31,0,0,0-9.05,0C267.09,406.3,260.71,404.52,262.78,408.67Z",
    style: {
      fill: "rgb(96, 116, 203)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "272.796px 410.394px"
    },
    id: "el0o0xl3b2iw3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.25,380.32s1.85,4.33,7.41,10.51S318,406.9,318,410c0,0-3.4-9.89-6.8-14.22s-9-7.41-10.2-11.12S302.25,380.32,302.25,380.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "309.335px 395.16px"
    },
    id: "elbd6ywtxfnoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,410s-1.86,1.23-2.78,5.25,5.25,6.8,5.25,6.8a6.46,6.46,0,0,1-.31-5C321.1,414.31,321.71,413.39,318,410Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.001px 416.025px"
    },
    id: "el7f1o83obw87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.74,390.45c2.11-3.69,3.29-9.22,2.24-12s-3.43-6.06-5.41-6.33-4.87.27-5.66-.26-9-4.61-12.92-7.78S266.73,359,259.88,359s-13.18.4-16.74,0-5.53-1.45-9.09-.79-7,3.3-9.23,3.69a24.94,24.94,0,0,1-3.95.4s-5.8-2.37-6.19-2.9c0,0-.66.4-1.32-.66s-.13-2-2.64-1.58a2.66,2.66,0,0,0-2.5,2.5s-3.3,2-4,2.51-5.27,4.74-6.72,6.19-1.58,1.71-4.08,4.22-3.82,2.63-4.35,4.08c-.43,1.17.78,2.52,1.95,3.75a2.65,2.65,0,0,0,1.93.82h0a20.22,20.22,0,0,0,3-.75l.84-.26a2.52,2.52,0,0,1-1.28,1.27c-.49.24-1,.52-1,1a7.2,7.2,0,0,0,2.65-.18,31.34,31.34,0,0,0,5.53-2.63,55.07,55.07,0,0,0,8.7.52c2.77-.26,6.59-2.11,7.51-2.5s5.93,1.05,7,2a16.49,16.49,0,0,1,3.56,7c.52,2.64,2.24,7.51,3.82,8.57s15.55,10.94,22.4,13.18,19.25,1.31,21.49.66,4-1.32,4-1.32,4.61,4.74,7.51,5.4a35.62,35.62,0,0,1,4.29,1.19,24.79,24.79,0,0,0-1,4.87c0,1.59-1.06,3.69-1.72,5.8s-1.18,4.88-2.37,6.46-3,4.22-3.29,5.67,1.71,1.45,2.24,1.18,2.63-1.05,2.76-2.37a23.2,23.2,0,0,1,1.19-4.35c.26-.66,2.37-2.77,2.77-5a21.81,21.81,0,0,1,1.45-5.27c.52-1.05,3-4.61,3.42-6.59a11.06,11.06,0,0,0-.92-6.59c-1.05-2.63-2.11-6.45-2-7.11A108.5,108.5,0,0,1,300.74,390.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "246.175px 397.778px"
    },
    id: "elvnf7twq33u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "248.645px 404.822px"
    },
    id: "elbmfwcq5hvjb",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.74,390.45a21.49,21.49,0,0,0,2-5,23.51,23.51,0,0,0-5.32,3.3c-3.38,3-4.39,6.41-3.71,11.47s-2,5.05-5.4,5.73-6.07-2-8.09-5.06-5.55,3.15-11.47,4.05-26-3.71-29.33-7.82-.34-13.76-.34-13.76a33.51,33.51,0,0,1-7.42-3.38c-3-2-5.06-8.43-8.77-8.76s-5.39,2.69-9.1,4.72-6.41,0-10.12,1.35c-1.56.56-4.32,1.85-7,3.15a2.8,2.8,0,0,1-1.12,1c-.49.24-1,.52-1,1a7.2,7.2,0,0,0,2.65-.18,31.34,31.34,0,0,0,5.53-2.63,55.07,55.07,0,0,0,8.7.52c2.77-.26,6.59-2.11,7.51-2.5s5.93,1.05,7,2a16.49,16.49,0,0,1,3.56,7c.52,2.64,2.24,7.51,3.82,8.57s15.55,10.94,22.4,13.18,19.25,1.31,21.49.66,4-1.32,4-1.32,4.61,4.74,7.51,5.4a35.62,35.62,0,0,1,4.29,1.19,24.79,24.79,0,0,0-1,4.87c0,1.58-1.06,3.69-1.72,5.8s-1.18,4.88-2.37,6.46-3,4.22-3.29,5.67,1.71,1.45,2.24,1.18,2.63-1.05,2.76-2.37a23.2,23.2,0,0,1,1.19-4.35c.26-.66,2.37-2.77,2.77-5a21.81,21.81,0,0,1,1.45-5.27c.52-1.05,3-4.61,3.42-6.59a11.06,11.06,0,0,0-.92-6.59c-1.05-2.63-2.11-6.45-2-7.11A108.5,108.5,0,0,1,300.74,390.45Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "248.645px 404.822px"
    },
    id: "elgssztc6xvj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.74,390.45c2.11-3.69,3.29-9.22,2.24-12s-3.43-6.06-5.41-6.33-4.87.27-5.66-.26-9-4.61-12.92-7.78S266.73,359,259.88,359s-13.18.4-16.74,0-5.53-1.45-9.09-.79-7,3.3-9.23,3.69a24.94,24.94,0,0,1-3.95.4s-5.8-2.37-6.19-2.9c0,0-.66.4-1.32-.66s-.13-2-2.64-1.58a2.66,2.66,0,0,0-2.5,2.5s-3.3,2-4,2.51-5.27,4.74-6.72,6.19-1.58,1.71-4.08,4.22-3.82,2.63-4.35,4.08c-.43,1.17.78,2.52,1.95,3.75a2.65,2.65,0,0,0,1.93.82h0a20.22,20.22,0,0,0,3-.75l.84-.26a2.52,2.52,0,0,1-1.28,1.27c-.49.24-1,.52-1,1a7.2,7.2,0,0,0,2.65-.18,31.34,31.34,0,0,0,5.53-2.63,55.07,55.07,0,0,0,8.7.52c2.77-.26,6.59-2.11,7.51-2.5s5.93,1.05,7,2a16.49,16.49,0,0,1,3.56,7c.52,2.64,2.24,7.51,3.82,8.57s15.55,10.94,22.4,13.18,19.25,1.31,21.49.66,4-1.32,4-1.32,4.61,4.74,7.51,5.4a35.62,35.62,0,0,1,4.29,1.19,24.79,24.79,0,0,0-1,4.87c0,1.59-1.06,3.69-1.72,5.8s-1.18,4.88-2.37,6.46-3,4.22-3.29,5.67,1.71,1.45,2.24,1.18,2.63-1.05,2.76-2.37a23.2,23.2,0,0,1,1.19-4.35c.26-.66,2.37-2.77,2.77-5a21.81,21.81,0,0,1,1.45-5.27c.52-1.05,3-4.61,3.42-6.59a11.06,11.06,0,0,0-.92-6.59c-1.05-2.63-2.11-6.45-2-7.11A108.5,108.5,0,0,1,300.74,390.45Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "246.175px 397.778px"
    },
    id: "elpwh2y4c9b4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.25,399.62a28.17,28.17,0,0,1,10.68,1.78c5,2.08,10.38-.59,13.35-.89s5.93,2.08,2.37,3.56-7.42.89-9.79,2.08a13.92,13.92,0,0,1-7.12,1.48c-3,0-5.34-1.18-8.31-1.78a50.07,50.07,0,0,1-6.23-1.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "259.739px 403.632px"
    },
    id: "el9y41yyoejjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,397.15c-1.79-3.37-4.71-5.61-2-9.2s.67-7.18-.45-8.53-2.91-2.47-4.49-4.94-1.34-3.36-.22-4.93,1.8-4.49,0-5.84-3.59-.67-6.51-1.12a4.49,4.49,0,0,1-1.59-.62,24.46,24.46,0,0,1-3.25.28s-5.8-2.37-6.19-2.9a.71.71,0,0,1-.56,0,6,6,0,0,1-1.87,2.76c-1.57.9-5.39,1.8-7,2.7s-2.46,1.57-3.36,1.57c-.56,0-.33-1.15.14-2.33-1.62,1.47-3.65,3.35-4.53,4.23s-1.21,1.26-1.85,1.93c.24.13,1.44.87.63,2.9-.9,2.24-.23,3.59,1.12,5.61s-.9.45-.67,2.69a1.29,1.29,0,0,0,.37.84h0a31.34,31.34,0,0,0,5.53-2.63,55.07,55.07,0,0,0,8.7.52c2.77-.26,6.59-2.11,7.51-2.5s5.93,1.05,7,2a16.49,16.49,0,0,1,3.56,7c.52,2.64,2.24,7.51,3.82,8.57.68.45,3.67,2.55,7.4,5A9.7,9.7,0,0,0,239.4,397.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.155px 379.78px"
    },
    id: "el2j9oe7ykxcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.59,382.59s2.22,4.63,1.21,8.86,1.21,7.25,3.22,9.66a19.84,19.84,0,0,0,6.85,5c2.41,1.21,4,.41,7.65,1s8.45,1.41,10.26,1.81a17.77,17.77,0,0,0,3.42.4s-10.46-4.83-16.91-12.07S233,384.2,232.83,382.79,227.59,377.36,227.59,382.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.895px 394.651px"
    },
    id: "elfnptujt7dov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,362.12s1.32-3.69,3.3-5.41,7.91-3.16,8.43-2.5-.79,4.61-2.76,6.85a6.8,6.8,0,0,1-5.28,2.51,8.56,8.56,0,0,0-2.1.26",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "219.012px 358.938px"
    },
    id: "eli7gpb28nwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.88,391.45a15.51,15.51,0,0,1-4.64,5.56c-3.09,2.16-9.88,4.32-9.88,7.11s-2.48,13.28-2.79,16.68-1.85,7.11-1.85,8,.62,4.32,1.85,4.63,4.33-2.47,5.26-4.94-.93-8.35-.93-8.35a5.94,5.94,0,0,0,.93-3.39c0-2.17.92-9,1.85-10.2s5.87-3.4,9.58-3.71,10.82-4.95,10.82-4.95",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.4px 412.452px"
    },
    id: "elivr2p01m55e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,362.09a22.34,22.34,0,0,1-11.43.31c-5.87-1.55-7.11,4.94-3.71,9.89s4.64,10.5,9.27,10.5,5.56-6.49,9.27-8.34,5.25-7.42,3.71-9.58S256.2,362.09,256.2,362.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.547px 372.44px"
    },
    id: "elsbabojhzsv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.72,373.38a4.18,4.18,0,0,0-2.15-1.25c-2-.26-4.87.27-5.66-.26s-9-4.61-12.92-7.78a17.32,17.32,0,0,0-4.12-2.31,8.12,8.12,0,0,1-1.05,7.42c-3.4,4.94-15.45,8.34-12.36,15.14s7.72,12.05,11.74,13,10.81-3.71,14.52-5.87,3.4-7.73,3.09-9.89,2.17-2.17,4.95-2.17C298.21,379.39,299.46,378,299.72,373.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.339px 379.623px"
    },
    id: "elhmxpqsgytwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.63,378.07s-1.35-2.24-2-1.12S190,382.11,193.63,378.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "192.316px 378.232px"
    },
    id: "el6bugkh8q266",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.08,368.9a1.61,1.61,0,1,1-1.61-1.61A1.61,1.61,0,0,1,210.08,368.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "208.47px 368.9px"
    },
    id: "elxd65qeuyd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,368.9a1,1,0,1,1-1-1A1,1,0,0,1,209.47,368.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.47px 368.9px"
    },
    id: "eljkjrpv45j8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.13,388.66s-3.4,5.26-3.4,9-4,8.65-6.49,11.74-3.09,6.8-1.85,8,4.33,9,5.87,12.06,1.86,5.25,3.09,5.56,3.71,3.71,5.56,3.4,2.48-2.48.62-5.26-2.16.93-4.63-3.09-2.17-8.65-3.71-10.5-2.78-2.78-2.16-4.33,6.48-8,8.65-9.89,8.34-3.71,12-6.49",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "240.723px 413.55px"
    },
    id: "eldoh3gxaq01",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "238.955px 418.935px"
    },
    id: "el88u7glsd5m9",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.68,405.35c1.56-1.34,5.2-2.67,8.51-4.36v-.07s-8.43,2.7-10.79,2.36c-1.72-.24-2-3.15-3-3.82-.95,3.39-4.12,7.3-6.21,9.91-2.47,3.09-3.09,6.8-1.85,8s4.33,9,5.87,12.06,1.86,5.25,3.09,5.56,3.71,3.71,5.56,3.4,2.48-2.48.62-5.26-2.16.93-4.63-3.09-2.17-8.65-3.71-10.5-2.78-2.78-2.16-4.33S239.51,407.21,241.68,405.35Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "238.955px 418.935px"
    },
    id: "eluvz4ucewr5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.13,388.66s-3.4,5.26-3.4,9-4,8.65-6.49,11.74-3.09,6.8-1.85,8,4.33,9,5.87,12.06,1.86,5.25,3.09,5.56,3.71,3.71,5.56,3.4,2.48-2.48.62-5.26-2.16.93-4.63-3.09-2.17-8.65-3.71-10.5-2.78-2.78-2.16-4.33,6.48-8,8.65-9.89,8.34-3.71,12-6.49",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "240.723px 413.55px"
    },
    id: "elt0nwnbz9ezn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.36,358.23s-3.82-.2-5,1.21-1,3.22,0,3.22S223.16,361.05,223.36,358.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.24191px",
      transformOrigin: "220.451px 360.44px"
    },
    id: "elbuy3xkl6nlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.15,
    cy: 368.52,
    r: 0.54,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "208.15px 368.52px"
    },
    id: "el9y991os2gxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,391.75c-2.71.55-9.73,2.39-10.53,6.39-.89,4.45,6.42,8.38,8,10-1.05-2.63-2.11-6.45-2-7.11A100.7,100.7,0,0,1,300,391.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.698px 399.945px"
    },
    id: "elkjg2rqio6ip",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "saiki--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.74,390.45c2.11-3.69,3.29-9.22,2.24-12s-3.43-6.06-5.41-6.33-4.87.27-5.66-.26-9-4.61-12.92-7.78S266.73,359,259.88,359s-13.18.4-16.74,0-5.53-1.45-9.09-.79-7,3.3-9.23,3.69a24.94,24.94,0,0,1-3.95.4s-5.8-2.37-6.19-2.9c0,0-.66.4-1.32-.66s-.13-2-2.64-1.58a2.66,2.66,0,0,0-2.5,2.5s-3.3,2-4,2.51-5.27,4.74-6.72,6.19-1.58,1.71-4.08,4.22-3.82,2.63-4.35,4.08c-.43,1.17.78,2.52,1.95,3.75a2.65,2.65,0,0,0,1.93.82h0a20.22,20.22,0,0,0,3-.75l.84-.26a2.52,2.52,0,0,1-1.28,1.27c-.49.24-1,.52-1,1a7.2,7.2,0,0,0,2.65-.18,31.34,31.34,0,0,0,5.53-2.63,55.07,55.07,0,0,0,8.7.52c2.77-.26,6.59-2.11,7.51-2.5s5.93,1.05,7,2a16.49,16.49,0,0,1,3.56,7c.52,2.64,2.24,7.51,3.82,8.57s15.55,10.94,22.4,13.18,19.25,1.31,21.49.66,4-1.32,4-1.32,4.61,4.74,7.51,5.4a35.62,35.62,0,0,1,4.29,1.19,24.79,24.79,0,0,0-1,4.87c0,1.59-1.06,3.69-1.72,5.8s-1.18,4.88-2.37,6.46-3,4.22-3.29,5.67,1.71,1.45,2.24,1.18,2.63-1.05,2.76-2.37a23.2,23.2,0,0,1,1.19-4.35c.26-.66,2.37-2.77,2.77-5a21.81,21.81,0,0,1,1.45-5.27c.52-1.05,3-4.61,3.42-6.59a11.06,11.06,0,0,0-.92-6.59c-1.05-2.63-2.11-6.45-2-7.11A108.5,108.5,0,0,1,300.74,390.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.241913891592246px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "saiki--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.13,388.66s-3.4,5.26-3.4,9-4,8.65-6.49,11.74-3.09,6.8-1.85,8,4.33,9,5.87,12.06,1.86,5.25,3.09,5.56,3.71,3.71,5.56,3.4,2.48-2.48.62-5.26-2.16.93-4.63-3.09-2.17-8.65-3.71-10.5-2.78-2.78-2.16-4.33,6.48-8,8.65-9.89,8.34-3.71,12-6.49",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.241913891592246px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfoCow);
export default __webpack_public_path__ + "static/media/ufoCow.88d1c20cb119d902cd81a2ce3ff94560.svg";
export { ForwardRef as ReactComponent };